export default {
    "fieldsList": {
      "flatHierarchyBox": "选择和安排列",
      "hierarchyBox": "选择数据",
      "filterBox": "报表筛选器",
      "rowBox": "行",
      "columnBox": "列",
      "measureBox": "值",
      "values": "数值",
      "allFields": "所有領域",
      "rows": "行",
      "columns": "列",
      "filters": "過濾器",
      "dropField": "放在這裡",
      "addCalculatedMeasure": "添加计算措施",
      "expandAll": "+ 全部展开",
      "collapseAll": "- 全部折叠",
      "formulasGroupName": "计算值",
      "title": "字段",
      "subtitle": "拖放字段進行排列"
    },
    "filter": {
      "ascSort": "Az",
      "descSort": "zA",
      "topX": "十大",
      "clearTopX": "明確 Top10",
      "top": "顶部",
      "bottom": "底部",
      "measuresPrompt": "选择措施",
      "search": "搜索",
      "selectAll": "全选",
      "selectAllResults": "選擇結果",
      "amountSelected": "{0} 的 {1} 选择",
      "amountFound": "{0} 的 {1} 中选择",
      "multipleItems": "多个项目",
      "all": "全",
      "sort": "分類:",
      "addGroup": "添加組",
      "groupName": "組 1",
      "ungroup": "取消組合"
    },
    "drillThrough": {
      "title": "详情",
      "row": "行: {0}",
      "column": "列: {0}",
      "value": "{0}: {1}"
    },
    "calculatedView": {
      "title": "計算值",
      "measureBox": "拖动措施到公式",
      "measureName": "度量值名称",
      "formula": "配方",
      "formulaPrompt": "在此處刪除值並編輯公式",
      "calculateIndividualValues": "计算个别价值",
      "removeValue": "去掉",
      "removeValueTitle": "去掉 {0}?",
      "removeValueMessage": "您確定要刪除此計算值嗎？",
      "header": "添加計算值",
      "allValues": "所有值"
    },
    "grid": {
      "total": "小计",
      "totals": "总计",
      "grandTotal": "汇总",
      "blankMember": "(blank)",
      "dateInvalidCaption": "Invalid date",
      "reportInformation": "Report Information"
    },
    "charts": {
      "showLegend": "显示图例",
      "hideLegend": "隐藏图例",
      "selectMeasures": "选择量度",
      "rowNumber": "行号",
      "bigDataSetWarning": "数据太多。请先筛选数据，才使用图表方式显示。",
      "flatTypesLimitation": "\"堆叠\"和\"柱状-趋势\"图表不适用于平面表。",
      "noDataTitle": "沒有數據顯示"
    },
    "tooltips": {
      "row": "行：",
      "column": "列：",
      "headerResize": "拖动以调整",
      "headerFit": "双击以适应",
      "filterIcon": "点击进行筛选",
      "filtered": "过滤",
      "expandIcon": "单击以展开",
      "collapseIcon": "按一下可折叠",
      "drillDown": "点击下钻",
      "drillUp": "点击上钻",
      "sortIcon": "点击降序排序",
      "sortedDescIcon": "单击\"升序排序",
      "sortedAscIcon": "点击降序排序",
      "close": "点击关闭"
    },
    "aggregations": {
      "average": {
        "caption": "平均",
        "totalCaption": "{0}的平均值",
        "grandTotalCaption": "{0}的总平均值"
      },
      "count": {
        "caption": "数值",
        "totalCaption": "{0}的计数",
        "grandTotalCaption": "{0}的总计数"
      },
      "difference": {
        "caption": "差额",
        "totalCaption": "{0}的差额",
        "grandTotalCaption": "{0}的总差额"
      },
      "distinctCount": {
        "caption": "不重复计数",
        "totalCaption": "{0}的不重复计数",
        "grandTotalCaption": "{0}的总不重复计数"
      },
      "index": {
        "caption": "指数",
        "totalCaption": "{0}的指数",
        "grandTotalCaption": "{0}的总指数"
      },
      "max": {
        "caption": "最大",
        "totalCaption": "{0}的最大值",
        "grandTotalCaption": "{0}的总最大值"
      },
      "min": {
        "caption": "最低限度",
        "totalCaption": "{0}的最小值",
        "grandTotalCaption": "{0}的总最小值"
      },
      "none": {
        "caption": "原值"
      },
      "percent": {
        "caption": "百分比",
        "totalCaption": "{0}的百分比",
        "grandTotalCaption": "{0}的总百分比"
      },
      "percentDifference": {
        "caption": "差额百分比",
        "totalCaption": "{0}的差额百分比",
        "grandTotalCaption": "{0}的总差额百分比"
      },
      "percentOfColumn": {
        "caption": "列百分比",
        "totalCaption": "{0}的列百分比",
        "grandTotalCaption": "{0}的总列百分比"
      },
      "percentOfRow": {
        "caption": "行百分比",
        "totalCaption": "{0}的行百分比",
        "grandTotalCaption": "{0}的总行百分比"
      },
      "product": {
        "caption": "物件",
        "totalCaption": "{0}的物件值",
        "grandTotalCaption": "{0}的总物件值"
      },
      "sum": {
        "caption": "总和",
        "totalCaption": "{0}的和",
        "grandTotalCaption": "{0}的总和"
      }
    },
    "messages": {
      "error": "错误！",
      "warning": "警告",
      "limitation": "限制!",
      "browse": "浏览",
      "confirmation": "确认",
      "reportFileType": "Flexmonster report file",
      "loading": "载入...",
      "loadingConfiguration": "载入配置...",
      "loadingData": "数据加载...",
      "uploading": "上传到服务器...",
      "waiting": "{0} 秒",
      "progress": "{0}К {1}К",
      "progressUnknown": "加载 {0}К",
      "analyzing": "数据分析...",
      "analyzingProgress": "{0}记录{1} ({2}%)",
      "analyzingRecords": "{0}% records",
      "saving": "Saving...",
      "loadingDimensions": "载入维度...",
      "loadingHierarchies": "载入结构...",
      "loadingMeasures": "载入量度...",
      "loadingKPIs": "Loading KPIs...",
      "loadingMembers": "载入构件...",
      "loadingProperties": "Loading properties...",
      "loadingLevels": "载入层次...",
      "fullscreen": "打开全屏？",
      "exportComplete": "数据已生成，请单击\"保存\"按钮保存数据。",
      "generatingPDF": "生成PDF",
      "pleaseWait": "请稍候",
      "pagesWereGenerated": "网页已生成",
      "exportProgress": "输出正在进行中...",
      "exportError": "Failed to export. An unexpected error occurred.",
      "cantSaveFile": "错误：无法保存文件。",
      "cantSaveToClipboard": "错误：无法写入到剪贴板。",
      "saveReportToFile": "报告可以保存到文件，请单击\"保存\"按钮保存报告。",
      "saveDataToFile": "Data is ready to be saved to file, please click \"Save\" button to save the file.",
      "loadReportFromFile": "选择要载入的报告",
      "inputNewName": "输入新的名称",
      "inputReportName": "请输入报告名称",
      "invalidDataSource": "用户没有当前多维数据集权限，请联系管理员设定访问权限。",
      "dataStreamError": "加載時發生流錯誤 '{0}'",
      "unableToOpenFile": "Unable to open file {0}.<br/><br/>It seems that this file doesn't exist or 'Access-Control-Allow-Origin' header is absent in the resource requested.<br/><br/><u><a href='https://www.flexmonster.com/doc/typical-errors/#unable-to-open-file' target='_blank'>Read more info about this error</a></u>",
      "unableTwoFileBrowsingSessions": "瀏覽文件對話框已打開.",
      "wrongFormulaFormat": "公式格式錯誤 請檢查",
      "inappropriateFileFormat": "數據文件格式不合適",
      "invalidJSONdata": "JSON數據無效",
      "excelCsvChartsExportError": "图表不能以Excel或CSV格式导出，请选择图像格式导出。",
      "excelPdfExportLimitation": "Export to Microsoft Excel or PDF is not available in the current edition.",
      "excelExportLimitation": "Export is not available in the current edition.",
      "noDataAvailable": "Data source is empty. Please check the CSV file.",
      "csvHeaderParsingError": "CSV header parsing error.",
      "dataWasUpdated": "Data source has been updated on the server. Refresh the report?",
      "cantConnectToAccelerator": "Cannot connect to data source. Please check if Flexmonster Accelerator is running.",
      "ocsvIncompatible": "Unable to read data source. It seems that OCSV file was compressed with a newer version. Please update the component to version {0} or newer.",
      "unknownError": "發生未知錯誤.",
      "invalidReportFormat": "報告格式無效或對文件的訪問被拒絕.",
      "tooManyColumnsInClassicMode": "經典表格的列數太多 切換佈局緊湊的形式.",
      "loadingSkin": "载入样式... {0}%",
      "selectFile": "选择要载入的CSV文件"
    },
    "kpis": {
      "kpis": "KPIs",
      "value": "Value",
      "goal": "Goal",
      "trend": "Trend",
      "status": "Status"
    },
    "buttons": {
      "ok": "好",
      "apply": "Apply",
      "cancel": "取消",
      "save": "保存",
      "clear": "抹去",
      "select": "浏览...",
      "yes": "Yes",
      "no": "No"
    },
    "contextMenu": {
      "drillThrough": "Drill through",
      "openFilter": "Open filter",
      "collapse": "Collapse",
      "expand": "Expand",
      "sortRowDesc": "Sort row desc",
      "sortRowAsc": "Sort row asc",
      "clearSorting": "Clear sorting",
      "sortColumnDesc": "Sort column desc",
      "sortColumnAsc": "Sort column asc"
    },
    "date": {
      "year": "一年",
      "quarter": "季",
      "month": "一个月",
      "day": "日"
    },
    "quarters": {
      "q1": "第1季度",
      "q2": "第2季度",
      "q3": "第3季度",
      "q4": "第4季度"
    },
    "months": {
      "january": "一月",
      "february": "二月",
      "march": "三月",
      "april": "四月",
      "may": "五月",
      "june": "六月",
      "july": "七月",
      "august": "八月",
      "september": "九月",
      "october": "十月",
      "november": "十一月",
      "december": "十二月"
    },
    "monthsShort": {
      "january": "Jan",
      "february": "Feb",
      "march": "Mar",
      "april": "Apr",
      "may": "May",
      "june": "Jun",
      "july": "Jul",
      "august": "Aug",
      "september": "Sep",
      "october": "Oct",
      "november": "Nov",
      "december": "Dec"
    },
    "weekdays": {
      "first": "Sunday",
      "second": "Monday",
      "third": "Tuesday",
      "fourth": "Wednesday",
      "fifth": "Thursday",
      "sixth": "Friday",
      "seventh": "Saturday"
    },
    "weekdaysShort": {
      "first": "Sun",
      "second": "Mon",
      "third": "Tue",
      "fourth": "Wed",
      "fifth": "Thu",
      "sixth": "Fri",
      "seventh": "Sat"
    },
    "toolbar": {
      "connect": "连接",
      "connect_local_csv": "本地CSV",
      "connect_local_ocsv": "本地OCSV",
      "connect_local_json": "本地JSON",
      "connect_remote_csv": "远程CSV",
      "connect_remote_csv_mobile": "CSV",
      "connect_remote_json": "远程JSON",
      "connect_remote_json_mobile": "JSON",
      "connect_olap": "OLAP (XMLA)",
      "connect_olap_mobile": "OLAP",
      "open": "打开",
      "local_report": "本地报告",
      "remote_report": "远程报告",
      "remote_report_mobile": "报告",
      "save": "保存",
      "load_json": "JSON报告",
      "grid": "表",
      "grid_flat": "平",
      "grid_classic": "经典",
      "grid_compact": "紧凑",
      "charts": "图表",
      
      "charts_bar": "条形图",
      "charts_bar_horizontal": "Bar",
      "charts_line": "折线图",
      "charts_scatter": "散点图",
      "charts_pie": "饼形图",
      "charts_bar_stack": "酒吧堆栈图",
      "charts_bar_line": "酒吧折线图",
      "charts_multiple": "多个值",
      "charts_multiple_disabled": "多个值不适用于",
      "format": "格式",
      "format_cells": "格式化单元格",
      "format_cells_mobile": "格式",
      "conditional_formatting": "条件格式",
      "conditional_formatting_mobile": "有条件",
      "options": "选项",
      "fullscreen": "全屏",
      "export": "出口",
      "export_print": "打印",
      "export_html": "HTML",
      "export_csv": "CSV",
      "export_excel": "Excel",
      "export_image": "Image",
      "export_pdf": "PDF",
      "fields": "字段",
      "ok": "好",
      "apply": "应用",
      "done": "完成",
      "cancel": "取消",
      "value": "值",
      "delete": "删除",
      "if": "如果",
      "then": "然后",
      "open_remote_csv": "打开远程CSV",
      "open_remote_json": "打开远程JSON",
      "csv": "CSV",
      "olap_connection_tool": "OLAP连接工具",
      "select_data_source": "选择数据源",
      "select_catalog": "选择目录",
      "select_cube": "选择多维数据集",
      "proxy_url": "代理URL",
      "data_source_info": "数据源信息",
      "catalog": "目录",
      "cube": "立方体",
      "credentials": "证书",
      "username": "用户名",
      "password": "密码",
      "open_remote_report": "打开远程报告",
      "choose_value": "選擇價值",
      "text_align": "文本对齐",
      "align_left": "剩下",
      "align_right": "对",
      "none": "没有",
      "space": "(空间)",
      "thousand_separator": "千分离器",
      "decimal_separator": "小数分隔符",
      "decimal_places": "小数位",
      "currency_symbol": "货币符号",
      "currency_align": "货币对齐",
      "null_value": "空值",
      "is_percent": "格式为百分比",
      "true_value": "真正",
      "false_value": "假",
      "conditional": "有条件",
      "add_condition": "添加条件",
      "less_than": "少于",
      "less_than_or_equal": "小于或等于",
      "greater_than": "比...更棒",
      "greater_than_or_equal": "大于或等于",
      "equal_to": "等于",
      "not_equal_to": "不等于",
      "between": "之间",
      "is_empty": "空",
      "all_values": "所有值",
      "and": "和",
      "and_symbole": "&",
      "cp_text": "文本",
      "cp_highlight": "突出",
      "layout_options": "布局选项",
      "layout": "布局",
      "compact_view": "紧凑型",
      "classic_view": "经典形式",
      "flat_view": "平面形式",
      "grand_totals": "总计",
      "grand_totals_off": "不显示总计",
      "grand_totals_on": "显示总计",
      "grand_totals_on_rows": "仅显示行总计",
      "grand_totals_on_columns": "仅显示列总计",
      "subtotals": "小计",
      "subtotals_off": "不显示小计",
      "subtotals_on": "显示小计",
      "subtotals_on_rows": "仅显示行小计",
      "subtotals_on_columns": "仅显示列小计",
      "choose_page_orientation": "选择页面方向",
      "landscape": "景观",
      "portrait": "肖像",
      "off_for_rows_and_columns": "关闭行和列",
      "on_for_rows_and_columns": "打开行和列",
      "on_for_rows": "仅对行",
      "on_for_columns": "仅对列",
      "do_not_show_subtotals": "不显示小计",
      "show_all_subtotals": "显示所有小计",
      "save_plan":"保存方案",
       "car_filter":"车型筛选",
       "model_settings":"返回筛选"
    }
  }